import { useLocation } from 'react-router-dom'
import NewsSection from '@presentation/components/sections/news/NewsSection'
import WebinarsSection from '@presentation/components/sections/webinars/WebinarsSection'
import HacksSection from '@presentation/components/sections/hacks/HacksSection'
import RecommendedActivitiesSection from '@presentation/components/sections/recommended-activities/RecommendedActivitiesSection'
import PodcastsSection from '@presentation/components/sections/podcasts/PodcastsSection'
import InstagramReelsSection from '@presentation/components/sections/instagram-reels/InstagramReelsSection'
import SeoHead from '@presentation/seo/SeoHead'

export default function HomePage() {
  const location = useLocation()
  const isHomeRoute = location.pathname === '/'

  return (
    <>
      {isHomeRoute ? (
        <SeoHead
          title="Parkinson's Insights | News, Webinars, Hacks, Podcasts, and Reels"
          description="Explore Parkinson's news, practical hacks, expert webinars, podcast episodes, and Instagram reels designed to help people with Parkinson's and caregivers make informed decisions."
          canonicalPath="/"
        />
      ) : null}
      <h1 className="sr-only">Parkinson&apos;s Insights</h1>
      <NewsSection />
      <WebinarsSection />
      <HacksSection />
      <PodcastsSection />
      <InstagramReelsSection />
      <RecommendedActivitiesSection />
    </>
  )
}
